import { useSelector } from 'react-redux'
import { selectRegionSettings } from '../../Auth/ducks'

export default function useScheduleSettings() {
  return useSelector(selectRegionSettings)?.module?.schedule
}
